import { render, staticRenderFns } from "./ViewShowAction.vue?vue&type=template&id=097d3854&scoped=true&"
import script from "./ViewShowAction.vue?vue&type=script&lang=js&"
export * from "./ViewShowAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d3854",
  null
  
)

export default component.exports